import React, { useEffect } from 'react';
import {
  CalendarFilters, Calendar, MeetingViewModel, EditMeeting, PageWrapper, 
  MeetingDetailedInformationModal,
} from '@components';
import { observer } from 'mobx-react-lite';
import { useViewModel } from '@utils';
import { isMobile } from 'react-device-detect';
import { CalendarViewModel } from './CalendarViewModel';
import { ScheduleCalendar } from './Schedule/ScheduleCalendar';
import '../../styles/views/calendarPage/calendarPage.scss';
import { AllRoomsLegend } from './AllRoomsLegend';

export const CalendarPage = observer(() => {

  const meetingViewModel = useViewModel(MeetingViewModel);
  const calendarViewModel = useViewModel(CalendarViewModel);

  useEffect(() => {
    calendarViewModel.onInit()
      .then(() => calendarViewModel.setFirstDayOfIntervalAsCurrent());
  }, []);

  return (
    isMobile 
      ? <ScheduleCalendar />
      : (
        <PageWrapper filterVisibility={!meetingViewModel.meetingData}>
          <div className="calendar-page-wrapper">
            {meetingViewModel.meetingData
              ? <EditMeeting />
              : (
                <>
                  <CalendarFilters />
                  {calendarViewModel.isAllRoomMeetingView && <AllRoomsLegend onClose={calendarViewModel.closeAllRoomMeetingView} />}
                  <Calendar />
                </>
              )
            }
          </div>
          {meetingViewModel.isShowMoreMeetingInformation && <MeetingDetailedInformationModal />}
        </PageWrapper>
      )
  );
});
